"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefundCreateTransport = exports.RefundTransport = exports.RefundLineItemInput = exports.RefundLineItemTransport = exports.RefundLineItemStorage = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const payment_processing_1 = require("./payment-processing");
exports.RefundLineItemStorage = typebox_1.Type.Object({
    originalLineItemID: typebox_1.Type.String({ format: 'uuid' }),
    /** Snapshot of the cancelled line's label. Optional — v1 refund creation does not write it. */
    itemName: typebox_1.Type.Optional(typebox_1.Type.String()),
    /** Snapshot of the cancelled line's description. Optional — v1 refund creation does not write it. */
    description: typebox_1.Type.Optional(typebox_1.Type.String()),
    quantity: typebox_1.Type.Number(),
    unitPrice: typebox_1.Type.Number(),
    totalPrice: typebox_1.Type.Number(),
    taxable: typebox_1.Type.Boolean(),
    tax: typebox_1.Type.Number(),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
});
exports.RefundLineItemTransport = typebox_1.Type.Object({
    originalLineItemID: typebox_1.Type.String({ format: 'uuid' }),
    quantity: typebox_1.Type.Number(),
    unitPrice: typebox_1.Type.Number(),
    unitPriceDollars: typebox_1.Type.Number(),
    totalPrice: typebox_1.Type.Number(),
    totalPriceDollars: typebox_1.Type.Number(),
    taxable: typebox_1.Type.Boolean(),
    tax: typebox_1.Type.Number(),
    taxDollars: typebox_1.Type.Number(),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
});
exports.RefundLineItemInput = typebox_1.Type.Object({
    originalLineItemID: typebox_1.Type.String({ format: 'uuid' }),
    quantity: typebox_1.Type.Number(),
    unitPrice: typebox_1.Type.Optional(typebox_1.Type.Number()),
    unitPriceDollars: typebox_1.Type.Optional(typebox_1.Type.Number()),
    totalPrice: typebox_1.Type.Optional(typebox_1.Type.Number()),
    totalPriceDollars: typebox_1.Type.Optional(typebox_1.Type.Number()),
    taxable: typebox_1.Type.Boolean(),
    tax: typebox_1.Type.Optional(typebox_1.Type.Number()),
    taxDollars: typebox_1.Type.Optional(typebox_1.Type.Number()),
});
exports.RefundTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    date: typebox_1.Type.String(),
    amount: typebox_1.Type.Number(),
    amountDollars: typebox_1.Type.Number(),
    paymentMethod: common_1.PaymentMethod,
    refundedByUserID: typebox_1.Type.String(),
    refundIdentifier: typebox_1.Type.Optional(typebox_1.Type.String()),
    reason: typebox_1.Type.Optional(typebox_1.Type.String()),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    syncedWithAccounting: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    paymentProcessor: typebox_1.Type.Optional(payment_processing_1.SupportedPaymentProcessorTransport),
    paymentProcessorRefundID: typebox_1.Type.Optional(typebox_1.Type.String()),
    paymentProcessorChargeID: typebox_1.Type.Optional(typebox_1.Type.String()),
    // `status` set for payments processed directly through our platform only right now. VOID exclusive to Rainforest-based payments.
    status: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.Literal('VOID'), typebox_1.Type.Literal('REFUND')])),
    lineItems: typebox_1.Type.Array(exports.RefundLineItemTransport),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    metadata: typebox_1.Type.Optional(typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserID: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserID: typebox_1.Type.String(),
    })),
});
exports.RefundCreateTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.RefundTransport, ['id', 'date', 'amount', 'amountDollars', 'refundedByUserID', 'lineItems', 'metadata']),
    typebox_1.Type.Object({
        date: typebox_1.Type.Optional(typebox_1.Type.String()),
        amount: typebox_1.Type.Optional(typebox_1.Type.Number()),
        amountDollars: typebox_1.Type.Optional(typebox_1.Type.Number()),
        lineItems: typebox_1.Type.Optional(typebox_1.Type.Array(exports.RefundLineItemInput)),
    }),
]);
//# sourceMappingURL=refund-transport.js.map